import classNames from "classnames";
import Footer from "../footer";
import Header from "../header";
import styles from "./style.module.scss";

const Wrapper = ({ children }: any) => {
  return (
    <div className={classNames(styles.bg)}>
      <Header />
      {children}
      <Footer />
    </div>
  );
};

export default Wrapper;
